import React from 'react';
import {
  SkeletonContent,
  SkeletonBlock,
  SkeletonLine
} from '@one-thd/sui-atomic-components';

const ProjectsDetailsBoxLoading = () => (
  <div
    data-component="ProjectsDetailsBoxLoading"
    data-testid="projects-details-box-loading"
    className="md:@xs:sui-min-w-96 sui-w-full sui-h-full sui-pr-4 sui-py-4"
  >
    <SkeletonContent disablePadding className="sui-w-full">
      <div className="sui-block md:@xs:sui-hidden">
        <SkeletonLine variant="multi" numberOfLines={2} />
      </div>
      <div className="sui-hidden md:@xs:sui-block">
        <SkeletonLine variant="multi" numberOfLines={3} />
      </div>
    </SkeletonContent>
  </div>
);

export const ProjectsLoading = () => {
  return (
    <div
      data-component="ProjectsLoading"
      data-testid="projects-container-loading"
    >
      {/* Header Section */}
      <div className="sui-flex">
        <SkeletonContent disablePadding initialSize="3/4">
          <SkeletonBlock aspect="wide" height={8} />
        </SkeletonContent>
      </div>

      <div className="
      sui-flex
      sui-flex-col
      md:@xs:sui-flex-row
      md:@xs:sui-flex-nowrap
      sui-gap-3
      md:@xs:sui-gap-4
      sui-w-full
      md:@xs:sui-overflow-auto"
      >
        {Array.from({ length: 4 }, (val, index) => (
          <div
            key={`project-skeleton-${index}`}
            className={index >= 3 ? 'sui-hidden md:@xs:sui-block' : ''}
          >
            <ProjectsDetailsBoxLoading />
          </div>
        ))}
      </div>
      <div className="sui-flex">
        <SkeletonContent disablePadding initialSize="3/4">
          <SkeletonBlock aspect="wide" height={8} />
        </SkeletonContent>
      </div>

    </div>
  );
};
